// Just creates a screen element and fades it in, then destroys it.
// CSS for this resides in partials/_main.scss or style it here is you want

let screenOverlay = document.createElement('div');
let rootElement = document.documentElement;
screenOverlay.setAttribute('id', 'js-screen__overlay');
screenOverlay.setAttribute('class', 'screen__overlay');
rootElement.appendChild(screenOverlay)

const Screen = function() {
  this.screenElement = screenOverlay;
  this.turnScreenOn();
  this.turnScreenOff();
}

Screen.prototype.turnScreenOn = function() {
	rootElement.setAttribute('data-freeze', true)
  this.screenElement.setAttribute('data-overlay',true);
}
Screen.prototype.turnScreenOff = function() {
	rootElement.removeAttribute('data-freeze')
  this.screenElement.removeAttribute('data-overlay');
}
Screen.prototype.element = function() {
  return this.screenElement;
}
module.exports = Screen;



// WEBPACK FOOTER //
// ./lib/screen.js